// extracted by mini-css-extract-plugin
export var avatarContainer = "_g8-0";
export var avatarTypingWave = "_g8-i";
export var gray = "_g8-f";
export var green = "_g8-c";
export var icon = "_g8-9";
export var image = "_g8-1";
export var lg = "_g8-6";
export var md = "_g8-5";
export var presenceDot = "_g8-b";
export var red = "_g8-d";
export var sm = "_g8-4";
export var status = "_g8-a";
export var typingDot = "_g8-h";
export var typingPill = "_g8-g";
export var xl = "_g8-7";
export var xs = "_g8-3";
export var xxl = "_g8-8";
export var xxs = "_g8-2";
export var yellow = "_g8-e";